import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { CheckoutRoutingModule } from './checkout-routing.module';
import { PaymentInformationComponent } from './purchase-and-summary/payment-information/payment-information.component';
import { SkeletonScreenModule } from '@daysmart/angular-skeleton-screen';
import { QaModule } from '@daysmart/angular-qa-module';
import { NotificationModule } from '../../shared/notification/notification.module';
import { GuestClientComponent } from './purchase-and-summary/payment-information/guest-client/guest-client.component';
import { CreditCardInformationComponent } from './purchase-and-summary/payment-information/credit-card-information/credit-card-information.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { DsiCurrencyModule } from 'src/app/shared/dsi-currency/dsi-currency.module';
import { SuccessfulPurchaseComponent } from './successful-purchase/successful-purchase.component';
import { MatIconModule } from '@angular/material/icon';
import { CheckoutComponent } from './checkout.component';
import { PurchaseAndSummaryComponent } from './purchase-and-summary/purchase-and-summary.component';
import { CheckoutFormService } from './purchase-and-summary/checkout-form-service/checkout-form.service';
import { SummaryComponent } from './purchase-and-summary/summary/summary.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentProcessingComponent } from './purchase-and-summary/payment-processing/payment-processing.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GiftCardIDModule } from 'src/app/shared/gift-card-id/gift-card-id.module';
import { NewCardComponent } from './purchase-and-summary/payment-information/existing-client/new-card/new-card.component';
import { SavedCardsComponent } from './purchase-and-summary/payment-information/existing-client/saved-cards/saved-cards.component';
import { ExistingClientComponent } from './purchase-and-summary/payment-information/existing-client/existing-client.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { LoginModule } from 'src/app/shared/login/login.module';
import { StripeManualComponent } from './purchase-and-summary/payment-information/stripe-manual/stripe-manual.component';

@NgModule({
    declarations: [
        CheckoutComponent,
        SummaryComponent,
        PaymentInformationComponent,
        SuccessfulPurchaseComponent,
        PurchaseAndSummaryComponent,
        GuestClientComponent,
        CreditCardInformationComponent,
        PaymentProcessingComponent,
        NewCardComponent,
        SavedCardsComponent,
        ExistingClientComponent,
        StripeManualComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CheckoutRoutingModule,
        MatCardModule,
        MatButtonModule,
        MatTabsModule,
        MatInputModule,
        SkeletonScreenModule,
        QaModule,
        NotificationModule,
        NgxMaskModule.forRoot(),
        DsiCurrencyModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        GiftCardIDModule,
        LoginModule,
        MatCheckboxModule,
        MatRadioModule,
    ],
    exports: [CreditCardInformationComponent],
    providers: [CheckoutFormService],
})
export class CheckoutModule {}
